export default {"src":"/_next/static/media/refer-a-friend_no-referrals.1046879b.svg","height":2000,"width":3161};